import React from "react";
import Button from "components/atoms/button";
import "./service-item.scss";
import { ImArrowUpRight2 } from "react-icons/im";

export const ServiceItem = (props: ServiceItemType) => {
  return (
    <div className="service__item p-1">
      <hr />
      <div className="row p-3">
        <div className="col-sm-2 col-md-2">
          <h6 className="counter">{props.id}/</h6>
        </div>
        <div className="col-sm-8 col-md-8">
          <h2>{props.text}</h2>
          <small>Explore</small>
        </div>
        <div className="col-sm-2 col-md-2">
          <div className="service__item__action">
            <Button onClick={() => props.onNavClick()} icon={<ImArrowUpRight2 />} classNames="primary" />
          </div>
        </div>
      </div>
    </div>
  );
};

export type ServiceItemType = {
    id: number | string,
    text: string,
    onNavClick: Function;
}
